module.exports = require('buffer')



//////////////////
// WEBPACK FOOTER
// ../~/safe-buffer/browser.js
// module id = 134
// module chunks = 0